import { apiClient, assertOk } from "@/api/generated/client"

import type { BalanceRegion } from "../types/balanceMapTypes"

export const getBalanceRegions = async (): Promise<BalanceRegion[]> => {
  const result = await apiClient.GET("/api/ForHire/balance-regions")
  const response = assertOk(result.response, result.error, result.data)

  return response as BalanceRegion[]
}
